import React, {ComponentProps, useEffect, useState} from 'react';
import {ExecutableModalProps} from "../../models/Modals";
import {Modal} from "antd";

type ModalProps = ExecutableModalProps<ComponentProps<typeof Modal> & {
  showBeforeOnShow?: boolean;
}>;

const ExecutableModal = ({
  handler,
  onShow,
  onHide,
  showBeforeOnShow = false,
  ...props
}: ModalProps) => {
  const [show, setShow] = useState<boolean>(false);

  const showHandle = async () => {
    if (showBeforeOnShow) {
      setShow(true);
    }
    if(onShow) {
      await onShow();
    }
    if (!showBeforeOnShow) {
      setShow(true);
    }
  };

  useEffect(() => {
    if(handler.modal) {
      void showHandle();
    }
  }, [handler.modal]);

  useEffect(() => {
    if(handler.close) {
      setShow(false);
      if(onHide) {
        void onHide();
      }
    }
  }, [handler.close]);

  return (
    <Modal
      {...props}
      onCancel={handler.executeClose}
      visible={show}
    />
  );
};

export default ExecutableModal;